module.exports = __webpack_public_path__ + "img/OnePunch1.9f5cc5ed.jpg";